module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-blog-1-686021ed2a444ad5b912b8ebd7a0aac7.jpg";